import { createContext } from 'react';

import { IRegistrationContext } from './registrationContext.interface';

export const RegistrationContext = createContext<IRegistrationContext | null>(null);
